// extracted by mini-css-extract-plugin
export default {"badge":"notification-badge_badge__yY36-","count":"notification-badge_count__nbMIq"};